import LoadingPage from '@components/common/Loading';
import Navbar from '@components/common/navbar/Navbar';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';

const LoadingLayout = () => {
  return (
    <BrowserRouter>
      <Navbar links={[]}></Navbar>
      <main className='h-screen'>
        <LoadingPage></LoadingPage>
      </main>
    </BrowserRouter>
  );
};

export default LoadingLayout;
